/**
 * 🟦 CUADRO NEGRO — Footer condicional por ruta.
 *
 * El footer legal "Términos · Privacidad" se oculta en las rutas internas
 * (Builder, Mis Apps, Builder Projects, Workspace, etc.) para no cortar
 * visualmente el contenido. Se mantiene en Home/Genio y páginas públicas.
 *
 * Rutas DONDE OCULTAR el footer:
 *   - /apps/:appId/builder
 *   - /my-apps
 *   - /builder-projects
 *   - /workspace (cualquier sub-ruta)
 *   - /dashboard
 *   - /admin
 */
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const HIDDEN_PREFIXES = [
  '/apps/',           // Builder + sub-rutas
  '/my-apps',
  '/builder-projects',
  '/workspace',
  '/dashboard',
  '/admin',
  '/developer',
];

export default function RouteAwareFooter() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) {
    return null;
  }
  return <Footer />;
}
